/**
 * A simple view element with two-way data binding.
 * WHO NEEDS ANGULAR (i'm just kidding, please kill me)
 *
 * @param options
 * @constructor
 */
window.ElementView = function(options) {
  this.element = $(options.selector || 'window');
  if(this.element.length === 0) {
    this.update = function(){};
    return;
  }
  this.value = options.value || null;
  this.update = options.update || function() {};
  this.init = options.init || function() {};
  this.init();
};
ElementView.prototype.set = function(value) {
  if(typeof value === 'object' && this.value !== null && this.equals(value, this.value)) {
    return;
  } else if(value === this.value) {
    return;
  }
  this.value = value;
  this.update(value);
};
ElementView.prototype.get = function() {
  return this.value;
};
/**
 * Quick, dirty one-level object compare
 * @param a
 * @param b
 * @return {boolean}
 */
ElementView.prototype.equals = function(a, b){
  if(typeof a !== typeof b) {
    return false;
  }
  for(var p in a){
    if(a.hasOwnProperty(p) && a[p] !== b[p]){
      return false;
    }
  }
  for(var p in b){
    if(b.hasOwnProperty(p) && a[p] !== b[p]){
      return false;
    }
  }
  return true;
};